import {IApiBaseUrlFactory} from './iApiBaseUrlFactory';
import { IApiInterceptor } from './iApiInterceptor';
import { IMsalAuthService } from './msal/msalAuthService';

export function apiInterceptor(ApiBaseUrlFactory: IApiBaseUrlFactory, $injector, $q: ng.IQService) {
    var interceptor = {
        request(config): Promise<ng.IRequestConfig> {
            if (config.url.indexOf('.html') > -1 ||
                config.url.indexOf('.svg') > -1 ||
                config.url.indexOf('logout') > -1 ||
                config.url.indexOf('login') > -1) {
                return config;
            }

            config.url = ApiBaseUrlFactory.get() + config.url;

            config.headers = config.headers || {};
            //if (sessionStorage.getItem("adal.idtoken")) {
            //    //config.headers.Authorization = sessionStorage.getItem("adal.idtoken");
            //    config.headers.Authorization = 'Bearer ' + sessionStorage.getItem("adal.idtoken");
            //}

            var tokenRequest = null;
            if (config.url.indexOf('//localhost') > -1) {
                tokenRequest = {
                    scopes: ["api://c20b038f-c692-447f-9a43-2b061a9755c5/API.Access"],
                };
            } else {
                tokenRequest = {
                    scopes: ["api://c20b038f-c692-447f-9a43-2b061a9755c5/API.Access"],
                };
            }

            //return config;

            return new Promise((resolve, reject) => {
                $injector.get('MsalAuthService').msal().acquireTokenSilent(tokenRequest)
                    .then(response => {
                        config.headers.Authorization = 'Bearer ' + response.accessToken;

                        if (config.url.indexOf('//localhost') > -1)
                            config.withCredentials = true; // needed for webpack

                        resolve(config);
                    })
                    .catch((e) => {
                        console.error('Exception retrieving access token : ', e)
                        reject(e);
                    });
            });
        },
        responseError(response: ng.IHttpPromiseCallbackArg<any>) {
            if (response.config === undefined || response.config.method === 'GET' || response.status === -1)
                {
                $injector.get('ExceptionalService').handleErrorResponse(response);
            }
            return $q.reject(response);
        }
    };
    return interceptor;
}

angular.module('deliveryCreate.app')
    .factory('apiInterceptor', apiInterceptor);


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/core/apiInterceptor.ts
 **/